// extracted by mini-css-extract-plugin
export default {"row":"UserEdit_row__v4O2o","switchAdjust":"UserEdit_switchAdjust__fgJBA"};